export default __webpack_public_path__ + "static/media/GraphikLCWeb-Bold.a3d864a4.woff";